// youtube-clone/src/App.js
import React, { useState, useEffect } from "react";
import SearchBar from "./components/SearchBar";
import VideoList from "./components/VideoList";
import VideoPlayer from "./components/VideoPlayer";
import youtube from "./services/youtube";
import "./App.css"; // Add custom CSS here

function App() {
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleSearch = async (term) => {
    try {
      const response = await youtube.get("/search", {
        params: {
          q: term,
        },
      });
      console.log("YouTube API response:", response.data); // Debugging
      setVideos(response.data.items || []);
      setSelectedVideo(response.data.items?.[0] || null);
    } catch (error) {
      console.error("YouTube API Error:", error);
      setVideos([]);
    }
  };

  useEffect(() => {
    handleSearch("latest music");
  }, []);

  return (
    <div className="app-container">
      <SearchBar onSearch={handleSearch} />
      <div className="main-content">
        <div className="video-player-section">
          {selectedVideo && <VideoPlayer video={selectedVideo} />}
        </div>
        <VideoList videos={videos} onVideoSelect={setSelectedVideo} />
      </div>
    </div>
  );
}

export default App;
